import { supabase } from './client';

// --- Storage: Logo Upload ---

export function getStoragePublicUrl(bucket: string, path: string): string {
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
}

export async function uploadLogo(bucket: 'team-logos' | 'club-logos', file: File, filename: string): Promise<string> {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? 'png';
  const path = `${filename}.${ext}`;
  const { error } = await supabase.storage.from(bucket).upload(path, file, {
    upsert: true,
    contentType: file.type,
  });
  if (error) throw error;
  return getStoragePublicUrl(bucket, path);
}

export async function deleteLogo(bucket: 'team-logos' | 'club-logos', path: string) {
  const { error } = await supabase.storage.from(bucket).remove([path]);
  if (error) throw error;
}
